import { render } from "./OneTiemCode.vue?vue&type=template&id=1890f923"
import script from "./OneTiemCode.vue?vue&type=script&lang=js"
export * from "./OneTiemCode.vue?vue&type=script&lang=js"
script.render = render

export default script